<!--
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-12-05 18:45:03
 * @LastEditors: Andy
 * @LastEditTime: 2022-12-05 18:46:34
-->
<template> </template>
<script>
  export default {
    name: 'XPageTab'
  }
</script>
